'use client';

import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import HeaderWidget from '@/components/HeaderWidget';

export default function Header() {
  const pathname = usePathname();
  const [iconColor, setIconColor] = useState('white');

  useEffect(() => {
    const update = () => setIconColor(window.innerWidth <= 991 ? 'black' : 'white');
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return (
    <HeaderWidget
      route={pathname}
      iconColor={iconColor}
      navLinkTextColor={iconColor}
      ctaBtnColor="white"
      ctaButtonLabel="Personal Zoom Coach"
      downloadButton={true}
      buttonLabel="Ask Angel"
      cdnBase={process.env.NEXT_PUBLIC_HEADER_CDN_BASE}
    />
  );
}
